import sessions from './user/sessions';

export default {
  strict: true,
  namespaced: true,
  state: {
  },
  modules: {
    sessions,
  },
};



// WEBPACK FOOTER //
// ./src/stores/map/models/user.js